import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { List, X, ArrowUpRight } from "@phosphor-icons/react";
import { NAV_LINKS } from "../data/site";

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="fixed top-0 left-0 right-0 z-50 border-b border-line bg-ink/80 backdrop-blur-xl">
      <div className="mx-auto flex h-20 max-w-[1600px] items-center justify-between px-6 md:px-12">
        <Link to="/" data-testid="nav-logo" aria-label="Prott Bauunternehmung — Startseite" className="flex items-center gap-3" onClick={() => setOpen(false)}>
          <img src="/assets/logo-white.png" alt="Prott Bauunternehmung Logo" className="h-12 w-auto md:h-14" />
        </Link>

        <nav className="hidden items-center gap-10 lg:flex" aria-label="Hauptnavigation">
          {NAV_LINKS.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              data-testid={`nav-link-${link.label.toLowerCase().replace(/ü/g, "ue").replace(/\s/g, "-")}`}
              className={({ isActive }) =>
                `group relative font-mono text-xs uppercase tracking-[0.2em] transition-colors duration-300 ${
                  isActive ? "text-ember" : "text-ash hover:text-bone"
                }`
              }
            >
              {link.label}
            </NavLink>
          ))}
          <Link
            to="/kontakt"
            data-testid="nav-contact-button"
            className="group flex items-center gap-2 border border-ember bg-ember px-6 py-3 font-mono text-xs uppercase tracking-[0.2em] text-ink transition-colors duration-300 hover:bg-transparent hover:text-ember"
          >
            Kontakt
            <ArrowUpRight size={14} weight="bold" className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          className="flex h-11 w-11 items-center justify-center border border-line text-bone lg:hidden"
          onClick={() => setOpen(!open)}
          aria-label={open ? "Menü schließen" : "Menü öffnen"}
        >
          {open ? <X size={20} /> : <List size={20} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            key={location.pathname + "-mobile"}
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
            className="overflow-hidden border-t border-line bg-ink lg:hidden"
            aria-label="Mobile Navigation"
          >
            <div className="flex flex-col px-6 py-8">
              {[...NAV_LINKS, { to: "/kontakt", label: "Kontakt" }].map((link, i) => (
                <motion.div
                  key={link.to}
                  initial={{ opacity: 0, x: -24 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 0.08 * i, duration: 0.4 }}
                >
                  <NavLink
                    to={link.to}
                    data-testid={`nav-mobile-${link.label.toLowerCase().replace(/ü/g, "ue").replace(/\s/g, "-")}`}
                    onClick={() => setOpen(false)}
                    className={({ isActive }) =>
                      `flex items-center justify-between border-b border-line py-5 font-display text-2xl font-semibold uppercase tracking-tight ${
                        isActive ? "text-ember" : "text-bone"
                      }`
                    }
                  >
                    {link.label}
                    <ArrowUpRight size={20} className="text-ash" />
                  </NavLink>
                </motion.div>
              ))}
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
